module.exports = __webpack_public_path__ + "static/media/urzaiz.5687f9e7.jpg";